import { get, API_URL } from '../utils/api';

/**
 * Fetch the runtime per-site rate config from the BFF.
 * @returns {Promise<Object>} Payload shaped { sites: { <lowercaseName>: config } }
 */
export const fetchSiteRates = async () => {
  const response = await get(`${API_URL}/site-rates`);
  return response.data;
};
